// AI Upgraded Component
import { ChangeDetectorRef, Component, Input, OnDestroy, OnInit } from '@angular/core';
import { DialogService } from '@monsido/angular-shared-components';
import { ExporterService } from '@client/app/modules/export/services/exporter.service';
import { ExporterAuditLogParserService } from '@client/app/modules/export/services/audit-log/audit-log.service';
import { Subscription } from 'rxjs';

@Component({
    selector: 'csv-export-audit-log-dialog',
    templateUrl: './dialog-auditlog.component.html',
    standalone: false,
})
export class CsvExportAuditLogDialogComponent implements OnInit, OnDestroy {
    @Input() monDialogId!: number;
    logs = 0;
    total = 0;
    subscription: Subscription | null = null;

    constructor (
        private readonly dialogService: DialogService,
        private readonly exporterService: ExporterService,
        private readonly auditLogService: ExporterAuditLogParserService,
        private readonly cdRef: ChangeDetectorRef,
    ) {}

    ngOnInit (): void {
        this.subscription = this.auditLogService.getAuditLogsProgressObs.subscribe(progress => {
            if (!progress) {
                return;
            }
            this.logs = progress.current;
            this.total = progress.total || 0;
            this.cdRef.markForCheck();
        });
    }

    ngOnDestroy (): void {
        this.subscription?.unsubscribe();
    }

    cancel (): void {
        this.exporterService.cancelAuditLog();
        this.dialogService.closeAll();
    }
}
